// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"styles_swiper-slide-active__rWHAt","title":"styles_title__Ifnme"};